import React from 'react';
import styles from './mainLogo.module.scss';
import { useGeneralHooks } from '../../../Hooks/hooks';

interface IProps {
    action?: boolean,
    actionLink?:string
};

const MainLogo: React.FC<IProps> = ({action=false,actionLink='/'}) => {
    const {navigate} = useGeneralHooks();

    return (
        <div className={styles.box} onClick={action ? ()=>navigate(actionLink) : ()=>{}}>
            <span className={styles.mr}>mr. </span>
            <span className={styles.byte}>Byte's</span>
            <p className={styles.bgText}>menu</p>
        </div>
    )
}

export default MainLogo
